import { Alert, AlertIcon } from '@chakra-ui/react'

export const ErrorState = () => (
  <Alert status="error" borderRadius="md" mt={4}>
    <AlertIcon />
    Failed to load interviewers. Please refresh the page.
  </Alert>
)
